var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricemonitoring-page"},[_c('PageProductCharts',{attrs:{"setLowPriceType":_vm.lowpricetype},on:{"updateData":_vm.updateLowPriceType}}),_c('PageProductTable',{attrs:{"getLowPriceType":_vm.lowpricetype}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }